import { datastoreActionSanitizer, } from '@freelancer/datastore';
import { environment } from '../environments/environment';
import { cookieOptionsFactory } from './cookie-options.factory';
/* The type for ActionSanitizer doesn't allow a custom action type.
 * ActionSanitizer probably should be
 *  export declare type ActionSanitizer<A extends Action = Action> = (
 *    action: A,
 *    id: number,
 *  ) => A;
 * but it isn't so let's cast through `any` for now.
 */
var actionSanitizer = datastoreActionSanitizer;
var ɵ0 = environment.authConfig, ɵ1 = environment.captchaConfig, ɵ2 = cookieOptionsFactory, ɵ3 = environment.siteName, ɵ4 = environment.seoConfig, ɵ5 = environment.appsDomainsMap, ɵ6 = environment.environmentName, ɵ7 = environment.appName, ɵ8 = environment.freelancerHttpConfig, ɵ9 = environment.whitelistCookie, ɵ10 = environment.arrowLoginSignupMarketingConfig, ɵ11 = environment.facebookConfig;
// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
// Application-wide code should be avoided as much as possible; does your code
// needs:
// - to be loaded on ALL logged-in pages?
// - AND to be loaded on ALL logged-out pages?
// - AND to be loaded on the Admin?
// - ...
// Probably not.
var AppCommonModule = /** @class */ (function () {
    function AppCommonModule() {
    }
    return AppCommonModule;
}());
export { AppCommonModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };
